<div class="project-machine-availability">
  <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
    <div>
      <h3 class="text-base font-semibold text-gray-900">Machine availability</h3>
      <p class="text-sm text-gray-500">
        {{ upcomingCount }} upcoming reservation{{ upcomingCount === 1 ? '' : 's' }} for this project
      </p>
    </div>
    <div class="flex flex-wrap gap-2">
      <button mat-stroked-button type="button" (click)="openBookDialog()">
        Book machine
      </button>
      <button mat-stroked-button type="button" (click)="openFullCalendar()">
        Full calendar
      </button>
    </div>
  </div>

  <p *ngIf="loading" class="text-sm text-gray-500 py-6 text-center">Loading reservations…</p>

  <ng-container *ngIf="!loading">
    <div class="flex items-center justify-between mb-3">
      <button mat-icon-button type="button" (click)="prevMonth()" aria-label="Previous month">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="text-sm font-medium text-gray-700">{{ calendarTitle }}</span>
      <button mat-icon-button type="button" (click)="nextMonth()" aria-label="Next month">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <div class="grid grid-cols-7 gap-px bg-gray-200 rounded-lg overflow-hidden border border-gray-200 mb-4">
      <div
        *ngFor="let wd of weekDays"
        class="bg-gray-50 text-center text-[11px] font-semibold text-gray-500 py-2"
      >
        {{ wd }}
      </div>
      <div
        *ngFor="let day of calendarDays"
        class="min-h-[72px] bg-white p-1"
        [class.bg-gray-50]="!day.inMonth"
        [class.ring-2]="day.isToday"
        [class.ring-inset]="day.isToday"
        [class.ring-blue-400]="day.isToday"
      >
        <div class="text-[11px] font-medium mb-0.5" [class.text-gray-400]="!day.inMonth">
          {{ day.date.getDate() }}
        </div>
        <div class="space-y-0.5">
          <button
            type="button"
            *ngFor="let r of day.reservations | slice:0:2"
            class="w-full text-left text-[9px] leading-tight text-white rounded px-0.5 py-px truncate"
            [ngClass]="reservationBarClass(r.status)"
            (click)="openBookDialog(r)"
            [title]="r.machine_name + ': ' + r.title"
          >
            {{ r.machine_name }}
          </button>
          <div *ngIf="day.reservations.length > 2" class="text-[9px] text-gray-400 px-0.5">
            +{{ day.reservations.length - 2 }}
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="reservations.length === 0" class="rounded-lg border border-dashed border-gray-300 p-6 text-center text-sm text-gray-500">
      No machine reservations linked to this project yet.
    </div>

    <div *ngIf="reservations.length > 0" class="overflow-x-auto rounded-lg border border-gray-200">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 text-left text-xs text-gray-500 uppercase">
          <tr>
            <th class="px-3 py-2">Machine</th>
            <th class="px-3 py-2">Title</th>
            <th class="px-3 py-2">Dates</th>
            <th class="px-3 py-2">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of reservations" class="border-t border-gray-100 hover:bg-gray-50">
            <td class="px-3 py-2 font-medium">{{ r.machine_name || r.machine_code }}</td>
            <td class="px-3 py-2">{{ r.title }}</td>
            <td class="px-3 py-2 whitespace-nowrap">
              {{ r.start_date | date:'mediumDate' }} – {{ r.end_date | date:'mediumDate' }}
            </td>
            <td class="px-3 py-2">
              <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium capitalize"
                [ngClass]="{
                  'bg-amber-100 text-amber-800': r.status === 'pending',
                  'bg-blue-100 text-blue-800': r.status === 'confirmed',
                  'bg-emerald-100 text-emerald-800': r.status === 'in_use',
                  'bg-gray-100 text-gray-700': r.status === 'completed',
                  'bg-red-100 text-red-700': r.status === 'cancelled'
                }">
                {{ r.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
